import type { SizeId } from "@/domain/types";
import { STICKER_SIZE_OPTION_VALUES } from "@/domain/size-contract";

export interface ShopifyConfig {
  storeDomain: string;
  storefrontAccessToken: string;
  stickerProductHandle: string;
  stickerSizeOptionName: string;
  stickerSizeOptionValues: Record<SizeId, string>;
}

// Re-export the shared size contract for existing integration callers.
export const SHOPIFY_STICKER_SIZE_OPTION_VALUES: Record<SizeId, string> = STICKER_SIZE_OPTION_VALUES;

function readRequiredPublicEnv(name: string): string {
  const value = process.env[name]?.trim();

  if (!value) {
    throw new Error(`Missing required Shopify config: ${name}`);
  }

  return value;
}

export function getShopifyConfig(): ShopifyConfig {
  return {
    storeDomain: readRequiredPublicEnv("NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN"),
    storefrontAccessToken: readRequiredPublicEnv(
      "NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN",
    ),
    stickerProductHandle: readRequiredPublicEnv(
      "NEXT_PUBLIC_SHOPIFY_NAME_STICKER_PRODUCT_HANDLE",
    ),
    stickerSizeOptionName:
      process.env.NEXT_PUBLIC_SHOPIFY_NAME_STICKER_SIZE_OPTION_NAME?.trim() || "Size",
    stickerSizeOptionValues: SHOPIFY_STICKER_SIZE_OPTION_VALUES,
  };
}
